export const SESSION_KEY = 'menti:dev-metrics:session';
export const USER_ID_KEY = 'menti:dev-metrics:userId';

export function sessionKey(appName: string): string {
  return `${SESSION_KEY}:${appName}`;
}
